export default __webpack_public_path__ + "c2ea950084ec9377617ab139464ecd0c.png";